import { useEffect, useState } from "react";
import axios from "axios";
import { aboutImage, verseOfTheWeek as mockVerse } from "../mock";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const defaultHp = {
  about_eyebrow: "About First Assembly",
  about_title_part1: "Where the thirsty",
  about_title_italic: "come to drink.",
  about_paragraph1: "For decades, First Assembly Living Waters has been a beacon in Big Spring, TX \u2014 a place where families grow, lives are restored, and hearts encounter the living God. We are an Assemblies of God congregation grounded in Scripture and led by the Holy Spirit.",
  about_paragraph2: "Whether you arrive curious, broken, or full of faith, you\u2019ll find a seat at the table. Come as you are; leave changed.",
  about_stat1_value: "60+", about_stat1_label: "Years Serving",
  about_stat2_value: "16", about_stat2_label: "Truths We Hold",
  about_stat3_value: "1", about_stat3_label: "Family in Christ",
};

export default function About() {
  const [verse, setVerse] = useState(mockVerse);
  const [hp, setHp] = useState(defaultHp);
  useEffect(() => {
    axios.get(`${API}/verse`).then(r => { if (r.data?.text) setVerse(r.data); }).catch(() => {});
    axios.get(`${API}/homepage`).then(r => { if (r.data) setHp({ ...defaultHp, ...r.data }); }).catch(() => {});
  }, []);
  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 h-24 w-24 border-t-2 border-l-2 border-[#c8a36a]" />
          <div className="absolute -bottom-6 -right-6 h-24 w-24 border-b-2 border-r-2 border-[#c8a36a]" />
          <img src={aboutImage} alt="Our church family" className="relative rounded-md shadow-[0_30px_60px_-30px_rgba(10,45,56,0.25)] w-full h-[520px] object-cover" />
          <div className="absolute -bottom-10 left-8 right-8 lg:left-16 lg:-right-12 bg-white border border-[#e8ecef] p-6 rounded-md shadow-xl">
            <Quote className="h-5 w-5 text-[#c8a36a] mb-2" />
            <p className="text-lg text-[#0a2d38] leading-snug italic">&ldquo;{verse.text}&rdquo;</p>
            <div className="mt-3 text-xs uppercase tracking-[0.26em] text-[#c8a36a] font-bold">{verse.reference}</div>
          </div>
        </div>

        <div>
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-4">{hp.about_eyebrow}</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] leading-[1.05] tracking-tight">
            {hp.about_title_part1} <span className="text-[#c8a36a]">{hp.about_title_italic}</span>
          </h2>
          <div className="mt-6 space-y-5 text-[#4a5b62] leading-relaxed text-[17px]">
            <p>{hp.about_paragraph1}</p>
            <p>{hp.about_paragraph2}</p>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-10 pt-8 border-t border-[#e8ecef]">
            <div>
              <div className="text-3xl font-bold text-[#0a2d38]">{hp.about_stat1_value}</div>
              <div className="text-xs uppercase tracking-wider text-[#7a8a8f] mt-1 font-semibold">{hp.about_stat1_label}</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#0a2d38]">{hp.about_stat2_value}</div>
              <div className="text-xs uppercase tracking-wider text-[#7a8a8f] mt-1 font-semibold">{hp.about_stat2_label}</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#0a2d38]">{hp.about_stat3_value}</div>
              <div className="text-xs uppercase tracking-wider text-[#7a8a8f] mt-1 font-semibold">{hp.about_stat3_label}</div>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="/what-we-believe" className="btn-teal rounded-full px-6 py-3">What We Believe</a>
            <a href="#visit" className="btn-outline-teal rounded-full px-6 py-3">Plan a Visit</a>
          </div>
        </div>
      </div>
    </section>
  );
}
